import React from 'react';
import { useIntl } from 'react-intl';
import Select from "react-dropdown-select";
import MediaQuery from 'react-responsive'; 
import ReactGA from 'react-ga';

import Header from '../Header';
import Footer from '../Footer';

import styles from './RegionSelector.module.css';
import { ASK_AN_EXPERT_REGION, SELECT_REGION } from '../../utils/constants';

const selectOptions = [
  {
    label: 'Belarus (Russian)',
    value: 'BY',
  },
  {
    label: 'Croatia',
    value: 'HR',
  },
  {
    label: 'Cyprus (English)',
    value: 'CY',
  },
  {
    label: 'Czech Republic',
    value: 'CS',
  },
  {
    label: 'Hungary',
    value: 'HU',
  },
  {
    label: 'Israel',
    value: 'IL',
  },
  {
    label: 'Middle East (English)',
    value: 'ME',
  },
  {
    label: 'Poland',
    value: 'PL',
  },
  {
    label: 'Romania',
    value: 'RO',
  },
  {
    label: 'Russia',
    value: 'RU',
  },
  {
    label: 'Slovakia',
    value: 'SK',
  },
  {
    label: 'Other countries (English)',
    value: 'EN',
  },
];

const RegionSelector = () => {

  const { formatMessage } = useIntl();

  const selectRegion = (e) => {
    const [ { value } ] = e;
    document.cookie = `chosenRegion=${value}; Expires=Wed, 31 Dec 9999 00:00:0 GMT;`;
    ReactGA.set({ dimension2: SELECT_REGION });
    window.location.reload();
  }

  return (
    <>
      <MediaQuery minDeviceWidth={1224}>
        <iframe
          src="https://www.youtube.com/embed/tDhH2BBA-ZY?controls=0&showinfo=0&autoplay=1&loop=1&disablekb=1&fs=0&playlist=tDhH2BBA-ZY"
          frameBorder="0"
          allow="autoplay; fullscreen"
          className={styles['video']}
          title="EPYC ads"
        ></iframe>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={1224}>
        <div className={styles['image']}></div>
      </MediaQuery>
      <div className={styles['body-container']}>
        <div className={styles['footer-container']}>
          <Footer></Footer>
        </div>
        <div className={`${styles['title']} Rubik-60pt`}>
          {formatMessage({id: 'RegionSelector.title'})}
        </div>
        <div className={styles['dropdown-container']}>
          <Select
            options={selectOptions}
            labelField="label"
            valueField="value"
            className={`${styles.dropdown} Rubik-26pt`}
            placeholder={formatMessage({id: 'RegionSelector.dropdownPlaceholder'})}
            onChange={selectRegion}
            dropdownPosition="auto"
            dropdownHeight="150px"
            style={{
              border: 'none',
            }}
          />
        </div>
      </div>
      <div className={styles['header-container']}>
        <Header gaValue={ASK_AN_EXPERT_REGION}></Header>
      </div>
    </>
  );
};

export default RegionSelector;
